var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"b-wave",staticStyle:{"background-color":"#f5f5f5"}}),_c('FooterComponent',{attrs:{"SpgData":_vm.SpgData}}),_c('ContactMobile',{attrs:{"SpgData":_vm.SpgData}}),_c('gotoTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }